import React from 'react'
import classNames from 'classnames'
import { WemoloCheckbox, WemoloTypography } from '../../../components/Wemolo'
import { CardSize, DETECTION_EXPLORER_CARD_SIZES, DETECTION_EXPLORER_TEXT } from '../config'
import { ClientFilters } from '../detectionFilters'
import styles from './ResultFilters.module.css'

const TEXT = DETECTION_EXPLORER_TEXT.resultFilters

export type ResultFiltersUIProps = {
    filters: ClientFilters
    /** Group-by-LP only: whether to show the LP-case checkboxes. */
    showLpFilters: boolean
    onChange: <K extends keyof ClientFilters>(key: K, value: boolean) => void
    /** Card-size scale, shown for the card views (gallery / group-by-LP), hidden for the table. */
    showCardSize: boolean
    cardSize: CardSize
    onCardSizeChange: (size: CardSize) => void
}

const Toggle: React.FC<{ checked: boolean; label: string; onChange: (value: boolean) => void }> = ({
    checked,
    label,
    onChange
}) => (
    <label className={styles.toggle}>
        <WemoloCheckbox checked={checked} onChange={(e) => onChange(e.target.checked)} />
        <WemoloTypography variant="body-small" tag="span">
            {label}
        </WemoloTypography>
    </label>
)

export const ResultFiltersUI: React.FC<ResultFiltersUIProps> = ({
    filters,
    showLpFilters,
    onChange,
    showCardSize,
    cardSize,
    onCardSizeChange
}) => (
    <div className={styles.bar}>
        <div className={styles.toggles}>
            <Toggle
                checked={filters.withImagesOnly}
                label={TEXT.withImagesOnly}
                onChange={(value) => onChange('withImagesOnly', value)}
            />
            {showLpFilters && (
                <>
                    <Toggle
                        checked={filters.lpWithImage}
                        label={TEXT.lpWithImage}
                        onChange={(value) => onChange('lpWithImage', value)}
                    />
                    <Toggle
                        checked={filters.lpWithError}
                        label={TEXT.lpWithError}
                        onChange={(value) => onChange('lpWithError', value)}
                    />
                </>
            )}
        </div>

        {showCardSize && (
            <div className={styles.sizeGroup} role="group" aria-label={TEXT.cardSizeLabel}>
                {DETECTION_EXPLORER_CARD_SIZES.map((size) => (
                    <button
                        key={size.key}
                        type="button"
                        aria-label={size.name}
                        aria-pressed={cardSize === size.key}
                        className={classNames(styles.sizeButton, {
                            [styles.sizeButtonActive]: cardSize === size.key
                        })}
                        onClick={() => onCardSizeChange(size.key)}
                    >
                        {size.label}
                    </button>
                ))}
            </div>
        )}
    </div>
)
